//Plugins
import axios from "axios";

//rutas
const rutaConsultarUbicaciones =
  "/api/Master/SolicitudInscripcion/ObtenerUbicaciones";
const rutaConsultarUbicacionLocal =
  "/api/Master/SolicitudInscripcion/ObtenerUbicacionLocal";
const rutaCodigoPostalExistente =
  "/api/Master/SolicitudInscripcion/ObtenerCodigoPostal";
const rutaColonias = "/api/Master/SolicitudInscripcion/ObtenerColonias";
const rutaCodigosPostales =
  "/api/Master/SolicitudInscripcion/ValidarCodigoPostal";
const rutaCiudad = "/api/Master/SolicitudInscripcion/ObtenerCiudad";
const rutaEstado = "/api/Master/SolicitudInscripcion/ObtenerEstado";
const rutaEnumProductos =
  "/api/Master/SolicitudInscripcion/ObtenerEnumProducto";
const rutaEnumServicios =
  "/api/Master/SolicitudInscripcion/ObtenerEnumServicio";
const rutaPaises = "/api/Master/SolicitudInscripcion/ListarPaises";

// SeccionPagos
const rutaEnumTiposPago =
  "/api/Master/SolicitudInscripcion/ObtenerEnumTipoPago";
const rutaTipoTarjeta = "/api/Master/SolicitudInscripcion/ListarTipoTarjeta";

const rutaEnumSexos = "/api/Master/SolicitudInscripcion/ObtenerEnumSexo";
const rutaEnumIdentificacion =
  "/api/Master/SolicitudInscripcion/ObtenerEnumTipoIdentificacion";
const rutaEnumEstadoCivil =
  "/api/Master/SolicitudInscripcion/ObtenerEnumEstadoCivil";
const rutaEnumRegimenMatrimonial =
  "/api/Master/SolicitudInscripcion/ObtenerEnumRegimenMatrimonial";
const rutaProfesiones = "/api/Master/SolicitudInscripcion/ListarProfesiones";
const rutaGiros = "/api/Master/SolicitudInscripcion/ListarGiros";
const rutaPuestos = "/api/Master/SolicitudInscripcion/ListarPuestos";
const rutaRegimenesFiscales = "/api/Master/SolicitudInscripcion/ListarRegimenFiscal";

const rutaEnumTipoVivienda =
  "/api/Master/SolicitudInscripcion/ObtenerEnumTipoVivienda";
const rutaEnumTiposEmpleo =
  "/api/Master/SolicitudInscripcion/ObtenerEnumTipoEmpleo";
const rutaEnumGradoEstudios =
  "/api/Master/SolicitudInscripcion/ObtenerEnumGradoEstudios";
const rutaEnumDivisas = "/api/Master/SolicitudInscripcion/ObtenerEnumDivisas";
const rutaEnumMediosPago =
  "/api/Master/SolicitudInscripcion/ObtenerEnumMediosPago";
const rutaEnumEnvioEstadoCuenta =
  "/api/Master/SolicitudInscripcion/ObtenerEnumEnvioEstadoCuenta";
const rutaEnumTiposIngreso =
  "/api/Master/SolicitudInscripcion/ObtenerEnumTipoIngreso";
const rutaEnumParentesco =
  "/api/Master/SolicitudInscripcion/ObtenerEnumParentesco";
const rutaGuardarIngresos =
  "/api/Master/SolicitudInscripcion/GuardarPerfilIngreso";
const rutaGuardarPuntosContacto =
  "/api/Master/SolicitudInscripcion/GuardarPuntoContacto";
const rutaGuardarBeneficiario =
  "/api/Master/SolicitudInscripcion/GuardarBeneficiarios";
const rutaGuardarReferencia =
  "/api/Master/SolicitudInscripcion/GuardarReferenciasPersonales";
const rutaCargarDatosProspecto = "/api/Master/Prospecto/ObtenerProspecto";
const rutaCargarTransicionProspecto = "/api/Master/Prospecto/ConsultaTransicionProspecto";
const rutaObtenerPersonalMoral = "/api/Master/Prospecto/ObtenerPersonaMoral";
const rutaObtenerFiguraId = "/api/Master/Prospecto/ObtenerFiguraId";
const rutaEliminarBeneficiario =
  "/api/Master/SolicitudInscripcion/EliminarBeneficiario";
const rutaEliminarReferenciaPersonal =
  "/api/Master/SolicitudInscripcion/EliminarReferenciaPersonal";
const rutaConsultarSolicitudGeneral =
  "/api/Master/SolicitudInscripcion/ObtenerSolicitudInscripcion";
const rutaConsultarSolicitudPersonaFisica =
  "/api/Master/SolicitudInscripcion/ObtenerSolicitudInscripcionPersonaFisica";
const rutaConsultarPerfilIngreso =
  "/api/Master/SolicitudInscripcion/ObtenerPerfilIngreso";
const rutaConsultarPuntosContacto =
  "/api/Master/SolicitudInscripcion/ObtenerPuntosContacto";
const rutaConsultarBeneficiarios =
  "/api/Master/SolicitudInscripcion/ObtenerBeneficiarios";
const rutaConsultarReferencias =
  "/api/Master/SolicitudInscripcion/ObtenerReferencias";
var rutaConsultarCuestionario =
  "/api/Master/CuestionarioPreAnalisisPersonaMoral/ConsultarCuestionario";

const rutaSolicitudTieneObservacion =
  "/api/Master/IntegracionExpediente/ConsultarObservacionSolicitud";
const rutaGuardarUbicacion =
  "/api/Master/SolicitudInscripcion/GuardarUbicacionGeneral";
const rutaGuardarUbicacionLocal =
  "/api/Master/SolicitudInscripcion/GuardarUbicacionLocal";
const rutaConsultarUbicacionExtranjera =
  "/api/Master/SolicitudInscripcion/ObtenerUbicacionExtranjera";
const rutaGuardarUbicacionExtranjera =
  "/api/Master/SolicitudInscripcion/GuardarUbicacionExtranjera";

const rutaObtenerTipoPersona =
  "/api/Master/Prospecto/ObtenerTipoPersona";

// var coloniaIdParticular = 0;
// var coloniaIdOficina = 0;
// var coloniaIdFiscal = 0;

const EnIngles = {
  params: {
    enIngles: null
  }
};

export default {
  methods: {
    //CONSULTAR CUESTIONARIO PREANÁLISIS DE UN PROSPECTO MORAL
    ConsultarCuestionario(prospectoId) {
      const prospecto = {
        params: {
          prospectoId: prospectoId
        }
      };
      axios
        .get(rutaConsultarCuestionario, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            let respuesta = resp.data.data;
            this.CuestionarioPersonaMoralId = respuesta.cuestionarioPreAnalisisPersonaMoralId;
            this.cuestionarioCompletado = respuesta.completado;
            this.CuestionarioTieneObservacion(this.ProspectoId, 3);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    CuestionarioTieneObservacion(prospecto, entidad) {
      const parametroProspectoId = {
        params: {
          prospectoId: prospecto,
          entidad: entidad
        }
      };
      axios
        .get(rutaSolicitudTieneObservacion, parametroProspectoId)
        .then(resp => {
          if (resp.data.estado === 0) {
            if (resp.data.data != null) {
              this.ObservacionCuestionarioPreanalisis = resp.data.data;
            } else {
              this.ObservacionCuestionarioPreanalisis = null;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    //BUSCAR OBSERVACION EN SOLCITUD DE RERESENTANTE LEGAL
    SolicitudRepresentanteTieneObservacion(representante, entidad) {
      const parametroRepresentante = {
        params: {
          prospectoId: representante,
          entidad: entidad
        }
      };
      axios
        .get(rutaSolicitudTieneObservacion, parametroRepresentante)
        .then(resp => {
          if (resp.data.estado === 0) {
            if (resp.data.data != null) {
              this.ObservacionSolicitudRepresentanteLegal = resp.data.data;
            } else {
              this.ObservacionSolicitudRepresentanteLegal = null;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    //Consultar solicitudes existentes de un prospecto
    async ConsultarSolicitudes(prospectoId, esRepresentanteLegal) {
      const prospecto = {
        params: {
          prospectoId: prospectoId
        }
      };
      await axios
        .get(
          "/api/Master/IntegracionExpediente/ConsultarSolicitudes",
          prospecto
        )
        .then(resp => {
          if (resp.data.estado === 0) {
            if (esRepresentanteLegal == true) {
              this.SolicitudRepresentanteId = resp.data.data;
              this.ConsultarSolicitudRepresentanteLegal(
                this.SolicitudRepresentanteId                
              );
            } else {
              this.SolicitudId = resp.data.data;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    //Esta función obtiene los datos ya existentes del prospecto como su nombre, número telefónico , correo, etc.
    CargarDatosProspecto(prospectoId) {
      const prospecto = {
        params: { prospectoId: prospectoId }
      };
      axios
        .get(rutaCargarDatosProspecto, prospecto)
        .then(response => {
          if (response.data.estado === 0) {
            this.DatosPersonaFisica.nombres = response.data.data.nombres;
            this.DatosPersonaFisica.apellidoPaterno =
              response.data.data.apellidoPaterno;
            this.DatosPersonaFisica.apellidoMaterno =
              response.data.data.apellidoMaterno;
            this.PuntoContactoGeneral.telefonoMovil.valor =
              response.data.data.telefono;
            this.PuntoContactoGeneral.correo1.valor = response.data.data.correo;
            this.etapaProspecto = response.data.data.etapaId;
            if (
              this.solicitudExistenteId != 0 &&
              this.solicitudExistenteId != null
            )
              this.ConsultarPuntosContacto(response.data.data.correo);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarProductos(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumProductos, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.productos = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExepcion(e);
        });
    },
    async CargarServicios(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumServicios, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.servicios = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarPaises(extranjero) {
      await axios
        .get(rutaPaises)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.paises = response.data.data;
            if (extranjero)
              this.OrdenarPaises(this.catalogos.paises)
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },

    // SeccionPago
    CargarTiposTarjeta(enIngles) {
      EnIngles.params.enIngles = enIngles;
      axios
        .get(rutaTipoTarjeta, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.tipotarjeta = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarTiposPago(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumTiposPago, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.tiposPago = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExepcion(e);
        });
    },
    async CargarSexos(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumSexos, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.sexos = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarTiposIdentificacion(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumIdentificacion, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            let tipos = response.data.data;
            if (enIngles) {
              this.catalogos.tiposIdentificacion = tipos;
            } else {
              this.catalogos.tiposIdentificacion = tipos.filter(
                tipo =>
                  tipo.text == "INE" ||
                  tipo.text == "CÉDULA PROFESIONAL" ||
                  tipo.text == "PASAPORTE"
              );
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarMediosPago(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumMediosPago, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.mediosPago = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarEstadosCiviles(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumEstadoCivil, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.estadosCiviles = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarRegimenesMatrimoniales(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumRegimenMatrimonial, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.regimenesMatrimoniales = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarProfesiones(esIngles) {
      await axios
        .get(rutaProfesiones)
        .then(response => {
          if (response.data.estado === 0) {
            let profesiones = response.data.data;
            if (esIngles) {
              this.catalogos.profesiones = profesiones.sort(function (a, b) {
                if (a.descripcionIngles < b.descripcionIngles) {
                  return -1;
                }
                if (a.descripcionIngles > b.descripcionIngles) {
                  return 1;
                }
                return 0;
              });
            } else {
              this.catalogos.profesiones = profesiones.sort(function (a, b) {
                if (a.descripcion < b.descripcion) {
                  return -1;
                }
                if (a.descripcion > b.descripcion) {
                  return 1;
                }
                return 0;
              });
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarGiros(esIngles) {
      await axios
        .get(rutaGiros)
        .then(response => {
          if (response.data.estado === 0) {
            let giros = response.data.data;
            if (esIngles) {
              this.catalogos.giros = giros.sort(function (a, b) {
                if (a.giroIngles < b.giroIngles) {
                  return -1;
                }
                if (a.giroIngles > b.giroIngles) {
                  return 1;
                }
                return 0;
              });
            } else {
              this.catalogos.giros = giros.sort(function (a, b) {
                if (a.giro < b.giro) {
                  return -1;
                }
                if (a.giro > b.giro) {
                  return 1;
                }
                return 0;
              });
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarRegimenesFiscales(esIngles, esPersonaMoral) {
      await axios
        .get(rutaRegimenesFiscales)
        .then(response => {
          if (response.data.estado === 0) {
            let regimenesFiscales = response.data.data;
            if (!esPersonaMoral) {
              regimenesFiscales = regimenesFiscales.filter(regimen => regimen.tipoCliente == 0);
            }
            else {
              regimenesFiscales = regimenesFiscales.filter(regimen => regimen.tipoCliente == 1);
            }
            if (esIngles) {
              this.catalogos.regimenesFiscales = regimenesFiscales.sort(function (a, b) {
                if (a.nombreRegimen < b.nombreRegimen) {
                  return -1;
                }
                if (a.nombreRegimen > b.nombreRegimen) {
                  return 1;
                }
                return 0;
              });
            } else {
              this.catalogos.regimenesFiscales = regimenesFiscales.sort(function (a, b) {
                if (a.nombreRegimen < b.nombreRegimen) {
                  return -1;
                }
                if (a.nombreRegimen > b.nombreRegimen) {
                  return 1;
                }
                return 0;
              });
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarPuestos(esIngles) {
      await axios
        .get(rutaPuestos)
        .then(response => {
          if (response.data.estado === 0) {
            let puestos = response.data.data;
            if (esIngles) {
              this.catalogos.puestos = puestos.sort(function (a, b) {
                if (a.puestoIngles < b.puestoIngles) {
                  return -1;
                }
                if (a.puestoIngles > b.puestoIngles) {
                  return 1;
                }
                return 0;
              });
            } else {
              this.catalogos.puestos = puestos.sort(function (a, b) {
                if (a.puesto < b.puesto) {
                  return -1;
                }
                if (a.puesto > b.puesto) {
                  return 1;
                }
                return 0;
              });
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarTiposVivienda(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumTipoVivienda, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.tiposVivienda = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarGradosEstudio(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumGradoEstudios, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.gradosEstudio = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarDivisas(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumDivisas, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.divisas = response.data.data;
            this.catalogos.divisas.forEach(d => (d.value = Number(d.value)));
            if (!enIngles) {
              this.DatosIngreso.divisa = this.catalogos.divisas[3].value;
              this.personaFisicaFiguraAdicional.divisa = this.catalogos.divisas[3].value;
            } else {
              this.DatosIngreso.divisa = this.catalogos.divisas[0].value;
              this.personaFisicaFiguraAdicional.divisa = this.catalogos.divisas[0].value;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarTiposEmpleo(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumTiposEmpleo, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.tiposEmpleo = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarTiposEnvioEC(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumEnvioEstadoCuenta, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.tiposEnvio = response.data.data;
            this.catalogos.tiposEnvio.forEach(t => (t.value = Number(t.value)));
            if (!enIngles) {
              //Revision - Replicar funcionamiento de cargar colonias de la funcion CargarColonias
              this.DatosSolicitudGeneral.envioEstadoCuenta = this.catalogos.tiposEnvio[0].value;
              // if(this.DatosSolicitudGeneral.envioEstadoCuentaOriginal) {this.DatosSolicitudGeneral.envioEstadoCuenta = this.DatosSolicitudGeneral.envioEstadoCuentaOriginal
              //   this.DatosSolicitudGeneral.envioEstadoCuentaOriginal = null;}
            } else {
              this.DatosSolicitudGeneral.envioEstadoCuenta = this.catalogos.tiposEnvio[1].value;
              // if(this.DatosSolicitudGeneral.envioEstadoCuentaOriginal) {this.DatosSolicitudGeneral.envioEstadoCuenta = this.DatosSolicitudGeneral.envioEstadoCuentaOriginal
              //   this.DatosSolicitudGeneral.envioEstadoCuentaOriginal = null;}
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarTiposIngreso(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumTiposIngreso, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.tiposIngreso = response.data.data;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async CargarParentescos(enIngles) {
      EnIngles.params.enIngles = enIngles;
      await axios
        .get(rutaEnumParentesco, EnIngles)
        .then(response => {
          if (response.data.estado === 0) {
            this.catalogos.parentescos = response.data.data;
            this.catalogos.parentescos.forEach(
              p => (p.value = Number(p.value))
            );
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    LimitarPorcentajeSocios(index){
      //     if(this.FormSocios[index].participacion > 100) {
      //       this.FormSocios[index].participacion = 100;
      //     }
      // },
      this.FormSocios[index].participacion = this.FormSocios[index].participacion != null ? parseFloat(this.FormSocios[index].participacion) : 0;
        if (this.FormSocios.length == 1) {
          if (this.FormSocios[0].participacion > 100) {
            this.FormSocios[0].participacion = 100;
          }
        } else {
          if (this.SumaPorcentajesSocios() > 100) {
            let resta = this.SumaPorcentajesSocios() - this.FormSocios[index].participacion;
            let faltante = 100 - resta;
            this.FormSocios[index].participacion = faltante;
          }
        }
      },
    LimitarPorcentaje(index) {
      this.FormBeneficiarios[index].porcentaje = this.FormBeneficiarios[index].porcentaje != null ? parseFloat(this.FormBeneficiarios[index].porcentaje) : 0;
      if (this.FormBeneficiarios.length == 1) {
        if (this.FormBeneficiarios[0].porcentaje > 100) {
          this.FormBeneficiarios[0].porcentaje = 100;
        }
      } else {
        if (this.SumaPorcentajes() > 100) {
          let resta = this.SumaPorcentajes() - this.FormBeneficiarios[index].porcentaje;
          let faltante = 100 - resta;
          this.FormBeneficiarios[index].porcentaje = faltante;
        }
      }
    },
    async ConsultarSolicitudGeneral() {
      const solicitud = {
        params: {
          solicitudId: this.solicitudExistenteId
        }
      };
      await axios
        .get(rutaConsultarSolicitudGeneral, solicitud)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.DatosSolicitudGeneral.solicitudId = resp.data.data.solicitudId;
            this.DatosSolicitudGeneral.prospectoId = resp.data.data.prospectoId;
            this.DatosSolicitudGeneral.producto = resp.data.data.producto;
            this.DatosSolicitudGeneral.servicio = resp.data.data.servicio;
            this.DatosSolicitudGeneral.expectativaAdjudicacion =
              resp.data.data.expectativaAdjudicacion;
            this.DatosSolicitudGeneral.medioAcercamiento =
              resp.data.data.medioAcercamiento;
            this.DatosSolicitudGeneral.fechaNacimiento =
              resp.data.data.fechaNacimiento != null
                ? resp.data.data.fechaNacimiento.substring(0, 10)
                : null;
            this.DatosSolicitudGeneral.envioEstadoCuenta = resp.data.data.envioEstadoCuenta;
            this.DatosSolicitudGeneral.enCasoAutorizacion =
              resp.data.data.enCasoAutorizacion;
            this.DatosSolicitudGeneral.requiereFactura =
              resp.data.data.requiereFactura;
            this.DatosSolicitudGeneral.aceptaInformacionTerceros =
              resp.data.data.aceptaInformacionTerceros;
            this.DatosSolicitudGeneral.aceptaInformacionPublicitaria =
              resp.data.data.aceptaInformacionPublicitaria;
            this.DatosSolicitudGeneral.seccionActual =
              resp.data.data.seccionActual != null
                ? resp.data.data.seccionActual
                : null;
            this.DatosSolicitudGeneral.solicitudCompletada =
              resp.data.data.solicitudCompletada;

            if (this.tipoUsuario != 3) {
              this.seccionActual = 1;
            } else {
              this.seccionActual =
                this.DatosSolicitudGeneral.seccionActual != 0
                  ? this.DatosSolicitudGeneral.seccionActual
                  : 1;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async ConsultarSolicitudPersonaFisica() {
      const solicitud = {
        params: {
          solicitudId: this.solicitudExistenteId
        }
      };
      await axios
        .get(rutaConsultarSolicitudPersonaFisica, solicitud)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.DatosPersonaFisica.solicitudId = resp.data.data.solicitudId;
            this.DatosPersonaFisica.nombreConyuge = resp.data.data.nombreConyuge;
            this.DatosPersonaFisica.rfc = resp.data.data.rfc;
            this.DatosPersonaFisica.numeroIdentificacion =
              resp.data.data.numeroIdentificacion;
            this.DatosPersonaFisica.nacionalidad = resp.data.data.nacionalidad;
            this.DatosPersonaFisica.sexo = resp.data.data.sexo;
            this.DatosPersonaFisica.lugarNacimiento =
              resp.data.data.lugarNacimiento;
            this.DatosPersonaFisica.curp = resp.data.data.curp;
            this.DatosPersonaFisica.tipoIdentificacion =
              resp.data.data.tipoIdentificacion;
            this.DatosPersonaFisica.estadoCivil = resp.data.data.estadoCivil;
            if (resp.data.data.regimenMatrimonial != null)
              this.DatosPersonaFisica.regimenMatrimonial =
                resp.data.data.regimenMatrimonial;
            this.DatosPersonaFisica.profesion = resp.data.data.profesion;
            this.DatosPersonaFisica.gradoEstudios =
              resp.data.data.gradoEstudios;
            this.DatosPersonaFisica.numeroDependientes =
              resp.data.data.numeroDependientes;
            this.DatosPersonaFisica.egresoMensual =
              resp.data.data.egresoMensual != null
                ? resp.data.data.egresoMensual.toString()
                : null;
            this.DatosPersonaFisica.tipoVivienda = resp.data.data.tipoVivienda;
            this.DatosPersonaFisica.tipoEmpleo = resp.data.data.tipoEmpleo;
            this.DatosPersonaFisica.departamentoEmpleo =
              resp.data.data.departamentoEmpleo;
            this.DatosPersonaFisica.nombreJefeDirecto =
              resp.data.data.nombreJefeDirecto;
            if (this.DatosSolicitudGeneral.requiereFactura == true) {
              this.DatosPersonaFisica.domicilioFiscal = resp.data.data.domicilioFiscal;
            }
            this.DatosPersonaFisica.regimenFiscalId = resp.data.data.regimenFiscalId;
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async ConsultarPerfilIngreso() {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId
        }
      };
      await axios
        .get(rutaConsultarPerfilIngreso, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            if (resp.data.data != null) {
              this.DatosIngreso.ingresoId = resp.data.data.ingresoId;
              this.DatosIngreso.tipoIngreso = resp.data.data.tipoIngreso;
              this.DatosIngreso.empresa = resp.data.data.empresa;
              this.DatosIngreso.giroEmpresa = resp.data.data.giroEmpresa;
              this.DatosIngreso.puesto = resp.data.data.puesto;
              this.DatosIngreso.giroEmpresaId = resp.data.data.giroId;
              this.DatosIngreso.puestoId = resp.data.data.puestoId;
              this.DatosIngreso.otroPuesto = resp.data.data.otroPuesto;
              this.DatosIngreso.monto =
                resp.data.data.monto != null
                  ? resp.data.data.monto.toString()
                  : null;
              this.DatosIngreso.antiguedadMeses =
                resp.data.data.antiguedadMeses;
              this.DatosIngreso.antiguedadAnios =
                resp.data.data.antiguedadAnios;
              this.DatosIngreso.utilidad = resp.data.data.utilidad;
              this.DatosIngreso.esPersonaMoral = resp.data.data.esPersonaMoral;
              this.DatosIngreso.divisa = resp.data.data.divisa;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarPuntosContacto(correoPrincipal) {
      const prospecto = {
        params: {
          prospectoId: this.ProspectoId,
          correoPrincipal: correoPrincipal
        }
      };
      axios
        .get(rutaConsultarPuntosContacto, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloPuntos = resp.data.data;
            for (var punto of arregloPuntos) {
              switch (punto.tipoContacto) {
                case 0:
                  this.PuntoContactoGeneral.telefonoFijo.puntoContactoId =
                    punto.puntoContactoId;
                  this.PuntoContactoGeneral.telefonoFijo.valor = punto.valor;
                  break;
                case 2:
                  this.PuntoContactoGeneral.telefonoMovil.puntoContactoId =
                    punto.puntoContactoId;
                  break;
                case 1:
                  this.PuntoContactoGeneral.telefonoFijoOficina.puntoContactoId =
                    punto.puntoContactoId;
                  this.PuntoContactoGeneral.telefonoFijoOficina.valor =
                    punto.valor;
                  break;
                case 4:
                  this.PuntoContactoGeneral.correo2.puntoContactoId =
                    punto.puntoContactoId;
                  this.PuntoContactoGeneral.correo2.valor = punto.valor;
                  break;
                case 6:
                  this.PuntoContactoConyuge.telefonoFijoConyuge.puntoContactoId =
                    punto.puntoContactoId;
                  this.PuntoContactoConyuge.telefonoFijoConyuge.valor =
                    punto.valor;
                  break;
                case 7:
                  this.PuntoContactoConyuge.telefonoMovilConyuge.puntoContactoId =
                    punto.puntoContactoId;
                  this.PuntoContactoConyuge.telefonoMovilConyuge.valor =
                    punto.valor;
                  break;
                case 8:
                  this.PuntoContactoConyuge.correoConyuge.puntoContactoId =
                    punto.puntoContactoId;
                  this.PuntoContactoConyuge.correoConyuge.valor = punto.valor;
                  break;
              }
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    SumaPorcentajesSocios() {
      let suma = this.FormSocios.reduce(
        (acc, obj) => acc + obj.participacion,
        0
      );
      return suma;
    },
    /**NUEVA LOGICA BENEFICIARIOS */
    SumaPorcentajes() {
      let suma = this.FormBeneficiarios.reduce(
        (acc, obj) => acc + obj.porcentaje,
        0
      );
      return suma;
    },
    CamposActualesVacios(index) {
      let llaves = Object.keys(this.FormBeneficiarios[index]);
      let vacios = 0;
      llaves.forEach(llave => {
        if (llave != "apellidoMaterno" && llave != "beneficiarioId")
          if (this.FormBeneficiarios[index][llave] === "" || this.FormBeneficiarios[index][llave] === null)
            vacios++;
      });
      return vacios > 0 ? true : false;
    },
    AgregarFormBeneficiario(esExtranjero) {
      if (this.FormBeneficiarios.length == 5) {
        if (esExtranjero)
          this.AlertaEmbajadores("Only five beneficiaries can be added.", true, true);
        else
          this.AlertaEmbajadores(
            "Solo se pueden agregar cinco beneficiarios.",
            true,
            false
          );
      } else if (this.camposVaciosBeneficiarioForm == false) {
        if (this.SumaPorcentajes() == 100) {
          if (esExtranjero)
            this.AlertaEmbajadores(
              "100% of beneficiaries are already covered.",
              true,
              true
            );
          else
            this.AlertaEmbajadores(
              "Ya se cubre el 100% entre beneficiarios.",
              true,
              false
            );
        } else {
          this.FormBeneficiarios.push({
            beneficiarioId: 0,
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            parentesco: null,
            porcentaje: null,
            telefono: null
          });
        }
      } else {
        if (esExtranjero)
          this.AlertaEmbajadores(
            "Please fill in all fields marked with an *",
            true,
            true
          );
        else
          this.AlertaEmbajadores(
            "Por favor llene todos los campos marcados con un *",
            true,
            false
          );
      }
    },
    EliminarBeneficiarioTest(index) {
      if (this.soloLectura != undefined && this.soloLectura == true) {
        this.AlertaEmbajadores(
          "No puede eliminar beneficiarios en el modo solo lectura.",
          true,
          false
        );
      } else {
        //if (this.FormBeneficiarios[index].beneficiarioId != 0) {
        if (this.FormBeneficiarios[index].beneficiarioId != 0 && this.FormBeneficiarios[index].beneficiarioId != null && this.FormBeneficiarios[index].beneficiarioId != undefined) {
          //Lo elimina de la base de datos
          const beneficiario = {
            params: {
              beneficiarioId: this.FormBeneficiarios[index].beneficiarioId
            }
          };
          axios
            .delete(rutaEliminarBeneficiario, beneficiario)
            .then(response => {
              if (response.data.estado === 1) {
                alert(response.data.mensaje);
              }
            })
            .catch(e => {
              this.ManejarExcepcion(e);
            });

          if (index > -1) {
            this.FormBeneficiarios.splice(index, 1);
          }
        } else {
          if (index > -1) {
            this.FormBeneficiarios.splice(index, 1);
          }
        }
      }
    },
    GuardarBeneficiariosTest(solicitudId) {
      for (var beneficiario of this.FormBeneficiarios) {
        if (
          this.CamposActualesVacios(
            this.FormBeneficiarios.indexOf(beneficiario)
          ) == false
        ) {
          //Se convierten a int los campos numéricos
          beneficiario.solicitudId = solicitudId;
          beneficiario.parentesco = parseInt(beneficiario.parentesco);
          beneficiario.porcentaje = parseFloat(beneficiario.porcentaje);
          //Se ejecuta la petición POST para cada beneficiario en el arreglo
          axios
            .post(rutaGuardarBeneficiario, beneficiario)
            .then(response => {
              if (response.data.estado === 1) {
                alert(response.data.mensaje);
              }
            })
            .catch(e => {
              this.ManejarExcepcion(e);
            });
        } else {
          this.AlertaEmbajadores(
            "No has llenado todos los campos requeridos.",
            true,
            false
          );
          return;
        }
      }
    },
    ConsultarBeneficiariosTest() {
      const solicitud = {
        params: {
          solicitudId: this.solicitudExistenteId
        }
      };
      axios
        .get(rutaConsultarBeneficiarios, solicitud)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloBeneficiarios = resp.data.data;
            if (arregloBeneficiarios.length > 0) {
              this.FormBeneficiarios = [];
              for (var item of arregloBeneficiarios) {
                let beneficiario = {
                  beneficiarioId: item.beneficiarioId,
                  solicitudId: item.solicitudId,
                  nombre: item.nombre,
                  apellidoPaterno: item.apellidoPaterno,
                  apellidoMaterno: item.apellidoMaterno,
                  parentesco: item.parentesco,
                  porcentaje: item.porcentaje * 100,
                  telefono: item.telefono
                };
                this.FormBeneficiarios.push(beneficiario);
              }
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    /**TERMINA NUEVA LOGICA BENEFICIARIOS */
    /**NUEVA LÓGICA REFERENCIAS */
    AgregarFormReferencia(esExtranjero) {
      if (this.FormReferencias.length >= 2) {
        if (esExtranjero)
          this.AlertaEmbajadores(
            "Only two personal references can be added.",
            true,
            true
          );
        else
          this.AlertaEmbajadores(
            "Solo se pueden agregar dos referencias personales.",
            true,
            false
          );
      } else if (this.camposVaciosReferenciaForm == false) {
        this.FormReferencias.push({
          nombre: null,
          apellidoPaterno: null,
          apellidoMaterno: null,
          relacion: null,
          correo: null,
          aniosRelacion: null,
          telefonoParticular: null,
          telefonoMovil: null
        });
      } else {
        if (esExtranjero)
          this.AlertaEmbajadores(
            "Please fill in all fields marked with an *",
            true,
            true
          );
        else
          this.AlertaEmbajadores(
            "Por favor llene todos los campos marcados con un *",
            true,
            false
          );
      }
    },
    EliminarReferenciaTest(index) {
      if (this.soloLectura != undefined && this.soloLectura == true) {
        this.AlertaEmbajadores(
          "No pueden eliminar referencias en el modo solo lectura.",
          true,
          false
        );
      } else {
        if (this.FormReferencias.length == 1) {
          this.FormReferencias[index].nombre = "";
          this.FormReferencias[index].apellidoPaterno = "";
          this.FormReferencias[index].apellidoMaterno = "";
          this.FormReferencias[index].relacion = null;
          this.FormReferencias[index].correo = null;
          this.FormReferencias[index].aniosRelacion = null;
          this.FormReferencias[index].telefonoParticular = null;
          this.FormReferencias[index].telefonoMovil = null;
          return;
        }

        if (
          this.FormReferencias[index].referenciaPersonalId != 0 &&
          this.FormReferencias[index].referenciaPersonalId != null &&
          this.FormReferencias[index].referenciaPersonalId != undefined
        ) {
          //Lo elimina de la base de datos
          const referencia = {
            params: {
              referenciaPersonalId: this.FormReferencias[index]
                .referenciaPersonalId
            }
          };
          axios
            .delete(rutaEliminarReferenciaPersonal, referencia)
            .then(response => {
              if (response.data.estado === 1) {
                alert(response.data.mensaje);
              }
            })
            .catch(e => {
              this.ManejarExcepcion(e);
            });
            this.FormReferencias.splice(index, 1);
        } else {
            this.FormReferencias.splice(index,1);
        }
      }
    },
    ConsultarReferenciasTest() {
      const solicitud = {
        params: {
          solicitudId: this.solicitudExistenteId
        }
      };
      axios
        .get(rutaConsultarReferencias, solicitud)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloReferencias = resp.data.data;
            if (arregloReferencias.length > 0) {
              this.FormReferencias = [];
              for (var item of arregloReferencias) {
                let referencia = {
                  referenciaPersonalId: item.referenciaPersonalId,
                  solicitudId: item.solicitudId,
                  nombre: item.nombre,
                  apellidoPaterno: item.apellidoPaterno,
                  apellidoMaterno: item.apellidoMaterno,
                  relacion: item.relacion,
                  correo: item.correo,
                  aniosRelacion: item.aniosRelacion,
                  telefonoParticular:
                    item.telefonoParticular == null
                      ? null
                      : item.telefonoParticular,
                  telefonoMovil: item.telefonoMovil
                };
                this.FormReferencias.push(referencia);
              }
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ReferenciaCamposVacios(index) {
      const ignoredKeys = [
        "solicitudId",
        "referenciaPersonalId",
        "apellidoMaterno",
        "correo",
        "telefonoParticular"
      ];
    
      const isEmpty = (value) =>
        value === null || value === undefined || value === "";
    
      const reference = this.FormReferencias[index];
      const emptyCount = Object.keys(reference).filter(
        (key) =>
          !ignoredKeys.includes(key) &&
          (key === "relacion" ? isEmpty(reference[key]) : isEmpty(reference[key]))
      ).length;
    
      return emptyCount;
    },
    ValidarRerencias(extranjero) {
      if (this.FormReferencias.length > 1) {
        let telefonosInvalidos = 0;
        let camposVacios = 0;
        this.FormReferencias.forEach(ref => {
          if (
            this.ReferenciaCamposVacios(this.FormReferencias.indexOf(ref)) > 0
          )
            camposVacios++;
        });
        if (camposVacios > 0) {
          return extranjero
            ? "Please fill in the required fields of the personal reference."
            : "No has llenado todos los campos marcados con * en tus referencias personales";
        } else {
          this.FormReferencias.forEach(r => {
            if (
              this.FormReferencias[this.FormReferencias.indexOf(r)]
                .telefonoMovil.length != 10
            ) {
              telefonosInvalidos++;
            } else if (
              this.FormReferencias[this.FormReferencias.indexOf(r)]
                .telefonoParticular != null &&
              this.FormReferencias[this.FormReferencias.indexOf(r)]
                .telefonoParticular != ""
            ) {
              if (
                this.FormReferencias[this.FormReferencias.indexOf(r)]
                  .telefonoParticular.length != 10
              ) {
                telefonosInvalidos++;
              }
            }
          });
        }
        if (telefonosInvalidos > 0) {
          return extranjero
            ? "The mobile phone of the personal reference must have 10 digits."
            : "Los telefonos móviles o fijos deben de contar con 10 dígitos.";
        }
      } else if (this.FormReferencias.length == 1) {
        if (this.ReferenciaCamposVacios(0) < 5) {
          if (this.ReferenciaCamposVacios(0) > 0) {
            return extranjero
              ? "Please fill in the required fields of the personal reference."
              : "No has llenado todos los campos marcados con * en tus referencias personales";
          } else if (this.FormReferencias[0].telefonoMovil.length != 10) {
            return extranjero
              ? "The mobile phone of the personal reference must have 10 digits."
              : "Los telefonos móviles o fijos deben de contar con 10 dígitos.";
          } else if (
            this.FormReferencias[0].telefonoParticular != null &&
            this.FormReferencias[0].telefonoParticular != ""
          ) {
            if (this.FormReferencias[0].telefonoParticular.length != 10) {
              return extranjero
                ? "The mobile phone of the personal reference must have 10 digits."
                : "Los telefonos móviles o fijos deben de contar con 10 dígitos.";
            } else {
              return "validas";
            }
          } else {
            return "validas";
          }
        }
      }
      return "validas";
    },
    GuardarReferenciasTest(solicitudId) {
      for (var referencia of this.FormReferencias) {
        //Se convierten a int los campos numéricos
        referencia.solicitudId = solicitudId;
        referencia.relacion = parseInt(referencia.relacion);
        referencia.aniosRelacion = parseInt(referencia.aniosRelacion);
        //Se ejecuta la petición POST para cada referencia en el arreglo
        axios
          .post(rutaGuardarReferencia, referencia)
          .then(response => {
            if (response.data.estado === 1) {
              alert(response.data.mensaje);
            }
          })
          .catch(e => {
            this.ManejarExcepcion(e);
          });
      }
    },
    /**NUEVA LÓGICA REFERENCIAS */
    ConsultarBeneficiarios() {
      const solicitud = {
        params: {
          solicitudId: this.solicitudExistenteId
        }
      };
      axios
        .get(rutaConsultarBeneficiarios, solicitud)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloBeneficiarios = resp.data.data;
            for (var item of arregloBeneficiarios) {
              let beneficiario = {
                beneficiarioId: item.beneficiarioId,
                solicitudId: item.solicitudId,
                nombre: item.nombre,
                apellidoPaterno: item.apellidoPaterno,
                apellidoMaterno: item.apellidoMaterno,
                parentesco: item.parentesco,
                porcentaje: item.porcentaje,
                telefono: item.telefono
              };
              this.beneficiarios.push(beneficiario);
              this.SumarPorcentaje(this.beneficiarios);
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarReferencias() {
      const solicitud = {
        params: {
          solicitudId: this.solicitudExistenteId
        }
      };
      axios
        .get(rutaConsultarReferencias, solicitud)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloReferencias = resp.data.data;
            for (var item of arregloReferencias) {
              let referencia = {
                referenciaPersonalId: item.referenciaPersonalId,
                solicitudId: item.solicitudId,
                nombre: item.nombre,
                apellidoPaterno: item.apellidoPaterno,
                apellidoMaterno: item.apellidoMaterno,
                relacion: item.relacion,
                correo: item.correo,
                aniosRelacion: item.aniosRelacion,
                telefonoParticular: item.telefonoParticular,
                telefonoMovil: item.telefonoMovil
              };
              this.referencias.push(referencia);
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    //Funciones para las tablas de benficiarios
    AgregarBeneficiario() {
      let formularioValidado = false;
      this.formularioBeneficiariosValidado = true;
      formularioValidado = this.$refs.formularioBeneficiarios.checkValidity();
      if (formularioValidado) {
        const beneficiario = {
          beneficiarioId: 0,
          solicitudId: null,
          nombre: this.DatosBeneficiario.nombre,
          apellidoPaterno: this.DatosBeneficiario.apellidoPaterno,
          apellidoMaterno: this.DatosBeneficiario.apellidoMaterno,
          parentesco: this.DatosBeneficiario.parentesco,
          porcentaje: this.DatosBeneficiario.porcentaje,
          telefono: this.DatosBeneficiario.telefono.toString()
        };
        this.beneficiarios.push(beneficiario);
        this.SumarPorcentaje(this.beneficiarios);
      }
    },
    EliminarBeneficiario(identificador) {
      if (this.soloLectura != undefined && this.soloLectura == true) {
        alert("No puede eliminar beneficiarios en el modo solo lectura.");
      } else {
        var index = this.beneficiarios
          .map(function (e) {
            return e.telefono;
          })
          .indexOf(identificador);

        if (this.beneficiarios[index].beneficiarioId != 0) {
          //Lo elimina de la base de datos
          const beneficiario = {
            params: {
              beneficiarioId: this.beneficiarios[index].beneficiarioId
            }
          };
          axios
            .delete(rutaEliminarBeneficiario, beneficiario)
            .then(response => {
              if (response.data.estado === 1) {
                alert(response.data.mensaje);
              }
            })
            .catch(e => {
              this.ManejarExcepcion(e);
            });

          if (index > -1) {
            this.beneficiarios.splice(index, 1);
            this.SumarPorcentaje(this.beneficiarios);
          }
        } else {
          if (index > -1) {
            this.beneficiarios.splice(index, 1);
            this.SumarPorcentaje(this.beneficiarios);
          }
        }
      }
    },
    SumarPorcentaje(arrBeneficiarios) {
      this.sumaBeneficiarios = arrBeneficiarios.reduce(
        (acumulador, obj) => acumulador + parseInt(obj.porcentaje),
        0
      );
      this.LimpiarCamposBeneficiarios();
    },
    LimpiarCamposBeneficiarios() {
      this.DatosBeneficiario.nombre = "";
      this.DatosBeneficiario.apellidoPaterno = "";
      this.DatosBeneficiario.apellidoMaterno = "";
      this.DatosBeneficiario.parentesco = null;
      this.DatosBeneficiario.porcentaje = null;
      this.DatosBeneficiario.telefono = null;
    },
    //Funciones para las tablas de benficiarios
    AgregarReferencia() {
      let formularioValidado = false;
      this.formularioReferenciasValidado = true;
      formularioValidado = this.$refs.formularioReferencias.checkValidity();
      if (formularioValidado) {
        const referenciaPersonal = {
          referenciaPersonalId: 0,
          solicitudId: null,
          nombre: this.DatosReferencia.nombre,
          apellidoPaterno: this.DatosReferencia.apellidoPaterno,
          apellidoMaterno: this.DatosReferencia.apellidoMaterno,
          relacion: this.DatosReferencia.relacion,
          correo: this.DatosReferencia.correo,
          aniosRelacion: this.DatosReferencia.aniosRelacion,
          telefonoParticular:
            this.DatosReferencia.telefonoParticular != null
              ? this.DatosReferencia.telefonoParticular.toString()
              : null,
          telefonoMovil: this.DatosReferencia.telefonoMovil.toString()
        };
        this.referencias.push(referenciaPersonal);
        this.LimpiarCamposReferencias();
      }
    },
    EliminarReferencia(identificador) {
      var index = this.referencias
        .map(function (e) {
          return e.correo;
        })
        .indexOf(identificador);

      if (this.referencias[index].referenciaPersonalId != 0) {
        //Lo elimina de la base de datos
        const referencia = {
          params: {
            referenciaPersonalId: this.referencias[index].referenciaPersonalId
          }
        };
        axios
          .delete(rutaEliminarReferenciaPersonal, referencia)
          .then(response => {
            if (response.data.estado === 1) {
              alert(response.data.mensaje);
            }
          })
          .catch(e => {
            this.ManejarExcepcion(e);
          });

        if (index > -1) {
          this.referencias.splice(index, 1);
        }
      } else {
        if (index > -1) {
          this.referencias.splice(index, 1);
        }
      }
    },
    LimpiarCamposReferencias() {
      this.DatosReferencia.nombre = "";
      this.DatosReferencia.apellidoPaterno = "";
      this.DatosReferencia.apellidoMaterno = "";
      this.DatosReferencia.relacion = null;
      this.DatosReferencia.correo = "";
      this.DatosReferencia.aniosRelacion = null;
      this.DatosReferencia.telefonoParticular = null;
      this.DatosReferencia.telefonoMovil = null;
    },
    //GUARDADO DE DATOS
    async GuardarIngresos(perfilIngresos) {
      await axios
        .post(rutaGuardarIngresos, perfilIngresos)
        .then(response => {
          if (response.data.estado === 1) {
            alert(response.data.mensaje);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    async GuardarPuntosDeContactoConyuge(esPersonaFisica, primerGuardado) {
      var llaves = Object.keys(this.PuntoContactoConyuge);
      var correoIdentity = "correoConyuge";
      llaves.forEach(async llave => {
        let puntocontacto = {
          puntocontactoId: this.PuntoContactoConyuge[llave].puntoContactoId,
          prospectoId: this.ProspectoId,
          tipoContacto: this.AsignarTipoPuntoContacto(llave),
          valor: this.PuntoContactoConyuge[llave].valor
        };
        if (primerGuardado) {
          if (
            this.PuntoContactoConyuge[llave].valor != null ||
            this.PuntoContactoConyuge[llave].valor != ""
          ) {
            await axios
              .post(rutaGuardarPuntosContacto, puntocontacto)
              .then(response => {
                if (response.data.estado === 0) {
                  //Hacer algo
                }
              })
              .catch(e => {
                this.ManejarExcepcion(e);
              });
          }
        } else {
          if (llave != correoIdentity) {
            if (
              this.PuntoContactoConyuge[llave].valor != null ||
              this.PuntoContactoConyuge[llave].valor != ""
            ) {
              await axios
                .post(rutaGuardarPuntosContacto, puntocontacto)
                .then(response => {
                  if (response.data.estado === 1) {
                    alert(response.data.mensaje);
                  }
                })
                .catch(e => {
                  this.ManejarExcepcion(e);
                });
            }
          }
        }
      });
    },
    async GuardarPuntosDeContacto(esPersonaFisica, primerGuardado) {
      var llaves = Object.keys(this.PuntoContactoGeneral);
      var correoIdentity = esPersonaFisica ? "correo1" : "correoMoral";
      llaves.forEach(async llave => {
        let puntocontacto = {
          puntocontactoId: this.PuntoContactoGeneral[llave].puntoContactoId,
          prospectoId: this.ProspectoId,
          tipoContacto: this.AsignarTipoPuntoContacto(llave),
          valor: this.PuntoContactoGeneral[llave].valor
        };
        if (primerGuardado) {
          if (
            this.PuntoContactoGeneral[llave].valor != null ||
            this.PuntoContactoGeneral[llave].valor != ""
          ) {
            await axios
              .post(rutaGuardarPuntosContacto, puntocontacto)
              .then(response => {
                if (response.data.estado === 0) {
                  //Hacer algo
                }
              })
              .catch(e => {
                this.ManejarExcepcion(e);
              });
          }
        } else {
          if (llave != correoIdentity) {
            if (
              this.PuntoContactoGeneral[llave].valor != null ||
              this.PuntoContactoGeneral[llave].valor != ""
            ) {
              await axios
                .post(rutaGuardarPuntosContacto, puntocontacto)
                .then(response => {
                  if (response.data.estado === 1) {
                    alert(response.data.mensaje);
                  }
                })
                .catch(e => {
                  this.ManejarExcepcion(e);
                });
            }
          }
        }
      });
    },
    AsignarTipoPuntoContacto(llave) {
      let tipo = null;
      switch (llave) {
        case "telefonoFijo":
          tipo = 0;
          break;
        case "telefonoMovil":
          tipo = 2;
          break;
        case "correo1":
          tipo = 3;
          break;
        case "correoRepresentante":
          tipo = 3;
          break;
        case "correo2":
          tipo = 4;
          break;
        case "correoMoral":
          tipo = 4;
          break;
        case "telefonoFijoOficina":
          tipo = 1;
          break;
        case "telefonoFijoConyuge":
          tipo = 6;
          break;
        case "telefonoMovilConyuge":
          tipo = 7;
          break;
        case "correoConyuge":
          tipo = 8;
          break;
      }
      return tipo;
    },
    GuardarBeneficiarios(solicitudId) {
      for (var beneficiario of this.beneficiarios) {
        //Se convierten a int los campos numéricos
        beneficiario.solicitudId = solicitudId;
        beneficiario.parentesco = parseInt(beneficiario.parentesco);
        beneficiario.porcentaje = parseFloat(beneficiario.porcentaje);
        //Se ejecuta la petición POST para cada beneficiario en el arreglo
        axios
          .post(rutaGuardarBeneficiario, beneficiario)
          .then(response => {
            if (response.data.estado === 1) {
              alert(response.data.mensaje);
            }
          })
          .catch(e => {
            this.ManejarExcepcion(e);
          });
      }
    },
    GuardarReferencias(solicitudId) {
      for (var referencia of this.referencias) {
        //Se convierten a int los campos numéricos
        referencia.solicitudId = solicitudId;
        referencia.relacion = parseInt(referencia.relacion);
        referencia.aniosRelacion = parseInt(referencia.aniosRelacion);
        //Se ejecuta la petición POST para cada referencia en el arreglo
        axios
          .post(rutaGuardarReferencia, referencia)
          .then(response => {
            if (response.data.estado === 1) {
              alert(response.data.mensaje);
            }
          })
          .catch(e => {
            this.ManejarExcepcion(e);
          });
      }
    },
    VerificarSoloLectura: function () {
      if (this.tipoUsuario == 0 || this.tipoUsuario == 2) {
        this.soloLectura = true;
      } else {
        this.soloLectura = false;
      }
    },
    SolicitudTieneObservacion(prospecto, entidad) {
      const parametroProspectoId = {
        params: {
          prospectoId: prospecto,
          entidad: entidad
        }
      };
      axios
        .get(rutaSolicitudTieneObservacion, parametroProspectoId)
        .then(resp => {
          if (resp.data.estado === 0) {
            if (resp.data.data != null) {
              this.observacionSolicitud = resp.data.data;
            }
          } else if (resp.data.estado === 1) {
            alert(resp.data.mensaje);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    //MÉTODOS PAR OBTENER Y GUARDAR UBICACIONES
    ConsultarUbicaciones(prospectoId) {
      const prospecto = {
        params: {
          prospectoId: prospectoId
        }
      };
      axios
        .get(rutaConsultarUbicaciones, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloUbicaciones = resp.data.data;
            for (var ubicacion of arregloUbicaciones) {
              switch (ubicacion.tipoUbicacion) {
                case 0:
                  this.DatosUbicacionGeneralParticular.ubicacionId =
                    ubicacion.ubicacionId;
                  this.DatosUbicacionGeneralParticular.prospectoId =
                    ubicacion.prospectoId;
                  this.DatosUbicacionGeneralParticular.tipoUbicacion =
                    ubicacion.tipoUbicacion;
                  this.DatosUbicacionGeneralParticular.calle =
                    ubicacion.calle != null ? ubicacion.calle : null;
                  this.DatosUbicacionGeneralParticular.numero =
                    ubicacion.numero != null ? ubicacion.numero : null;
                  this.DatosUbicacionGeneralParticular.direccionFacturacion = ubicacion.direccionFacturacion;
                  this.ConsultarUbicacionLocal(
                    ubicacion.ubicacionId,
                    ubicacion.tipoUbicacion
                  );
                  break;
                case 1:
                  this.DatosUbicacionGeneralOficina.ubicacionId =
                    ubicacion.ubicacionId;
                  this.DatosUbicacionGeneralOficina.prospectoId =
                    ubicacion.prospectoId;
                  this.DatosUbicacionGeneralOficina.tipoUbicacion =
                    ubicacion.tipoUbicacion;
                  this.DatosUbicacionGeneralOficina.calle =
                    ubicacion.calle != null ? ubicacion.calle : null;
                  this.DatosUbicacionGeneralOficina.numero =
                    ubicacion.numero != null ? ubicacion.numero : null;
                  this.DatosUbicacionGeneralOficina.direccionFacturacion = ubicacion.direccionFacturacion;
                  this.ConsultarUbicacionLocal(
                    ubicacion.ubicacionId,
                    ubicacion.tipoUbicacion
                  );
                  break;
                case 2:
                  this.DatosUbicacionGeneralFiscal.ubicacionId =
                    ubicacion.ubicacionId;
                  this.DatosUbicacionGeneralFiscal.prospectoId =
                    ubicacion.prospectoId;
                  this.DatosUbicacionGeneralFiscal.tipoUbicacion =
                    ubicacion.tipoUbicacion;
                  this.DatosUbicacionGeneralFiscal.calle =
                    ubicacion.calle != null ? ubicacion.calle : null;
                  this.DatosUbicacionGeneralFiscal.calle =
                    ubicacion.calle != null ? ubicacion.calle : null;
                  this.DatosUbicacionGeneralFiscal.numero =
                    ubicacion.numero != null ? ubicacion.numero : null;
                  this.DatosUbicacionGeneralFiscal.direccionFacturacion = ubicacion.direccionFacturacion;
                  this.ConsultarUbicacionLocal(
                    ubicacion.ubicacionId,
                    ubicacion.tipoUbicacion
                  );
                  break;
              }
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarUbicacionLocal(ubicacionId, tipoUbicacion) {
      const ubicacion = {
        params: {
          ubicacionId: ubicacionId
        }
      };
      axios
        .get(rutaConsultarUbicacionLocal, ubicacion)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.ConsultarCodigoPostalExistente(
              resp.data.data.coloniaId,
              tipoUbicacion
            );
            // if (tipoUbicacion == 0) { coloniaIdParticular = resp.data.data.coloniaId; }
            // else if (tipoUbicacion == 1) { coloniaIdOficina = resp.data.data.coloniaId; }
            // else if (tipoUbicacion == 2) { coloniaIdFiscal = resp.data.data.coloniaId; }
            switch (tipoUbicacion) {
              case 0:
                this.DatosUbicacionParticular.ubicacionId =
                  resp.data.data.ubicacionId;
                this.DatosUbicacionParticular.coloniaIdOriginal = resp.data.data.coloniaId;
                this.coloniaExistenteParticular = resp.data.data.coloniaId.toString();
                break;
              case 1:
                this.DatosUbicacionOficina.ubicacionId =
                  resp.data.data.ubicacionId;
                this.DatosUbicacionOficina.coloniaIdOficinaOriginal = resp.data.data.coloniaId;
                this.coloniaExistenteOficina = resp.data.data.coloniaId.toString();
                break;
              case 2:
                this.DatosUbicacionFiscal.ubicacionId =
                  resp.data.data.ubicacionId;
                this.DatosUbicacionFiscal.coloniaIdFiscalOriginal = resp.data.data.coloniaId;
                this.coloniaExistenteFiscal = resp.data.data.coloniaId.toString();
                break;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarCodigoPostalExistente(coloniaId, tipoUbicacion) {
      const colonia = {
        params: {
          coloniaId: coloniaId
        }
      };
      axios
        .get(rutaCodigoPostalExistente, colonia)
        .then(resp => {
          if (resp.data.data != null) {
            if (resp.data.estado === 0) {
              switch (tipoUbicacion) {
                case 0:
                  this.codigoPostalParticular = resp.data.data.descripcion;
                  break;
                case 1:
                  this.codigoPostalOficina = resp.data.data.descripcion;
                  break;
                case 2:
                  this.codigoPostalFiscal = resp.data.data.descripcion;
                  break;
              }
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarCodigoPostal(codigoPostal, tipoUbicacion) {
      const parametroCodigo = {
        params: {
          codigoPostal: codigoPostal
        }
      };
      return axios
        .get(rutaCodigosPostales, parametroCodigo)
        .then(resp => {
          if (resp.data.estado === 0) {
            if (resp.data.data != null) {
              this.CargarColonias(resp.data.data.codigoPostalId, tipoUbicacion);
              this.CargarCiudad(resp.data.data.ciudadId, tipoUbicacion);

              switch (tipoUbicacion) {
                case 0:
                  this.codigoPostalValido = true;
                  break;
                case 1:
                  this.codigoPostalValidoEmpresa = true;
                  break;
                case 2:
                  this.codigoPostalValidoFiscal = true;
                  break;
              }
            }
          } else if (resp.data.estado === 1) {
            switch (tipoUbicacion) {
              case 0:
                this.direccion.ciudad = "NO ENCONTRADO";
                this.direccion.estado = "NO ENCONTRADO";
                this.codigoPostalValido = false;
                this.catalogos.colonias = [];
                this.DatosUbicacionParticular.coloniaId = null;
                break;
              case 1:
                this.direccionEmpresa.ciudad = "NO ENCONTRADO";
                this.direccionEmpresa.estado = "NO ENCONTRADO";
                this.codigoPostalValidoEmpresa = false;
                this.catalogos.coloniasEmpresa = [];
                this.DatosUbicacionOficina.coloniaId = null;
                break;
              case 2:
                this.direccionFiscal.ciudad = "NO ENCONTRADO";
                this.direccionFiscal.estado = "NO ENCONTRADO";
                this.codigoPostalValidoFiscal = false;
                this.catalogos.coloniasFactura = [];
                this.DatosUbicacionFiscal.coloniaId = null;
                break;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    CargarCiudad(ciudadId, tipoUbicacion) {
      const parametroCiudad = {
        params: { ciudadId: ciudadId }
      };
      axios
        .get(rutaCiudad, parametroCiudad)
        .then(resp => {
          if (resp.data.estado === 0) {
            switch (tipoUbicacion) {
              case 0:
                this.direccion.ciudad = resp.data.data.descripcion;
                this.CargarEstado(resp.data.data.estadoId, 0);
                break;
              case 1:
                this.direccionEmpresa.ciudad = resp.data.data.descripcion;
                this.CargarEstado(resp.data.data.estadoId, 1);
                break;
              case 2:
                this.direccionFiscal.ciudad = resp.data.data.descripcion;
                this.CargarEstado(resp.data.data.estadoId, 2);
                break;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    CargarEstado(estadoId, tipoUbicacion) {
      const parametroEstado = {
        params: { estadoId: estadoId }
      };
      axios
        .get(rutaEstado, parametroEstado)
        .then(resp => {
          if (resp.data.estado === 0) {
            switch (tipoUbicacion) {
              case 0:
                this.direccion.estado = resp.data.data.descripcion;
                break;
              case 1:
                this.direccionEmpresa.estado = resp.data.data.descripcion;
                break;
              case 2:
                this.direccionFiscal.estado = resp.data.data.descripcion;
                break;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    CargarColonias(codigoPostalId, tipoUbicacion) {
      const parametroCodigo = {
        params: { codigoPostalId: codigoPostalId }
      };
      axios
        .get(rutaColonias, parametroCodigo)
        .then(resp => {
          if (resp.data.estado === 0) {
            switch (tipoUbicacion) {
              case 0:
                this.catalogos.colonias = resp.data.data;
                //this.DatosUbicacionParticular.coloniaId = coloniaIdParticular;
                if (
                  this.DatosUbicacionParticular.coloniaIdOriginal != null &&
                  this.DatosUbicacionParticular.coloniaIdOriginal > 0) {
                  this.DatosUbicacionParticular.coloniaId = this.DatosUbicacionParticular.coloniaIdOriginal;
                  this.DatosUbicacionParticular.coloniaIdOriginal = null;
                }
                break;
              case 1:
                this.catalogos.coloniasEmpresa = resp.data.data;
                //this.DatosUbicacionOficina.coloniaId = coloniaIdOficina;
                if (this.DatosUbicacionOficina.coloniaIdOficinaOriginal != null &&
                  this.DatosUbicacionOficina.coloniaIdOficinaOriginal > 0) {
                  this.DatosUbicacionOficina.coloniaId = this.DatosUbicacionOficina.coloniaIdOficinaOriginal;
                  this.DatosUbicacionOficina.coloniaIdOficinaOriginal = null;
                }
                break;
              case 2:
                this.catalogos.coloniasFactura = resp.data.data;
                //this.DatosUbicacionFiscal.coloniaId = this.catalogos.coloniasFactura[0].coloniaId;
                //this.DatosUbicacionFiscal.coloniaId = coloniaIdFiscal;
                if (this.DatosUbicacionFiscal.coloniaIdFiscalOriginal != null &&
                  this.DatosUbicacionFiscal.coloniaIdFiscalOriginal > 0) {
                  this.DatosUbicacionFiscal.coloniaId = this.DatosUbicacionFiscal.coloniaIdFiscalOriginal;
                  this.DatosUbicacionFiscal.coloniaIdFiscalOriginal = null;
                }
                break;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    GuardarUbicacionGeneralParticular(esExtranjero) {
      axios
        .post(rutaGuardarUbicacion, this.DatosUbicacionGeneralParticular)
        .then(resp => {
          if (resp.data.estado === 0) {
            let ubicacionId = resp.data.data;
            this.DatosUbicacionParticular.ubicacionId = ubicacionId;
            this.GuardarUbicacionParticular(
              this.DatosUbicacionParticular,
              esExtranjero
            );
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    GuardarUbicacionParticular(ubicacionParticular, esExtranjero) {
      axios
        .post(
          esExtranjero
            ? rutaGuardarUbicacionExtranjera
            : rutaGuardarUbicacionLocal,
          ubicacionParticular
        )
        .then(resp => {
          if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    GuardarUbicacionGeneralOficina(esExtranjero) {
      axios
        .post(rutaGuardarUbicacion, this.DatosUbicacionGeneralOficina)
        .then(resp => {
          if (resp.data.estado === 0) {
            let ubicacionId = resp.data.data;
            this.DatosUbicacionOficina.ubicacionId = ubicacionId;
            this.GuardarUbicacionOficina(
              this.DatosUbicacionOficina,
              esExtranjero
            );
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    GuardarUbicacionOficina(ubicacionOficina, esExtranjero) {
      axios
        .post(
          esExtranjero
            ? rutaGuardarUbicacionExtranjera
            : rutaGuardarUbicacionLocal,
          ubicacionOficina
        )
        .then(resp => {
          if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    GuardarUbicacionGeneralFiscal() {
      axios
        .post(rutaGuardarUbicacion, this.DatosUbicacionGeneralFiscal)
        .then(resp => {
          if (resp.data.estado === 0) {
            let ubicacionId = resp.data.data;
            this.DatosUbicacionFiscal.ubicacionId = ubicacionId;
            this.GuardarUbicacionFiscal(this.DatosUbicacionFiscal);
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    GuardarUbicacionFiscal(ubicacionFiscal) {
      axios
        .post(rutaGuardarUbicacionLocal, ubicacionFiscal)
        .then(resp => {
          if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },

    //MÉTODOS PARA OBTENER Y GUARDAR UBICACIONES EXTRANJERAS
    ConsultarUbicacionesExtranjeras(prospectoId) {
      const prospecto = {
        params: {
          prospectoId: prospectoId
        }
      };
      axios
        .get(rutaConsultarUbicaciones, prospecto)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloUbicaciones = resp.data.data;
            for (var ubicacion of arregloUbicaciones) {
              if (ubicacion.tipoUbicacion == 0) {
                this.DatosUbicacionGeneralParticular.ubicacionId =
                  ubicacion.ubicacionId;
                this.DatosUbicacionGeneralParticular.prospectoId =
                  ubicacion.prospectoId;
                this.DatosUbicacionGeneralParticular.tipoUbicacion =
                  ubicacion.tipoUbicacion;
                this.DatosUbicacionGeneralParticular.calle = ubicacion.calle;
                this.DatosUbicacionGeneralParticular.numero = ubicacion.numero;
                this.ConsultarUbicacionExtranjera(ubicacion.ubicacionId, true);
              } else {
                this.DatosUbicacionGeneralOficina.ubicacionId =
                  ubicacion.ubicacionId;
                this.DatosUbicacionGeneralOficina.prospectoId =
                  ubicacion.prospectoId;
                this.DatosUbicacionGeneralOficina.tipoUbicacion =
                  ubicacion.tipoUbicacion;
                this.DatosUbicacionGeneralOficina.calle = ubicacion.calle;
                this.DatosUbicacionGeneralOficina.numero = ubicacion.numero;
                this.ConsultarUbicacionExtranjera(ubicacion.ubicacionId, false);
              }
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ConsultarUbicacionExtranjera(ubicacionId, esParticular) {
      const ubicacion = {
        params: {
          ubicacionId: ubicacionId
        }
      };
      axios
        .get(rutaConsultarUbicacionExtranjera, ubicacion)
        .then(resp => {
          if (resp.data.estado === 0) {
            if (esParticular === true) {
              this.DatosUbicacionParticular.ubicacionId =
                resp.data.data.ubicacionId;
              this.DatosUbicacionParticular.paisId = resp.data.data.paisId;
              this.DatosUbicacionParticular.estado = resp.data.data.estado;
              this.DatosUbicacionParticular.ciudad = resp.data.data.ciudad;
              this.DatosUbicacionParticular.codigoPostal =
                resp.data.data.codigoPostal;
            } else {
              this.DatosUbicacionOficina.ubicacionId =
                resp.data.data.ubicacionId;
              this.DatosUbicacionOficina.paisId = resp.data.data.paisId;
              this.DatosUbicacionOficina.estado = resp.data.data.estado;
              this.DatosUbicacionOficina.ciudad = resp.data.data.ciudad;
              this.DatosUbicacionOficina.codigoPostal =
                resp.data.data.codigoPostal;
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    InvalidarCodigoPostal(tipo) {
      //particular = 1, oficina = 2, fiscal 3
      switch (tipo) {
        case "particular":
          this.direccion.ciudad = "NO ENCONTRADO";
          this.direccion.estado = "NO ENCONTRADO";
          this.codigoPostalValido = false;
          this.catalogos.colonias = [];
          this.DatosUbicacionParticular.coloniaId = null;
          break;
        case "oficina":
          this.direccionEmpresa.ciudad = "NO ENCONTRADO";
          this.direccionEmpresa.estado = "NO ENCONTRADO";
          this.codigoPostalValidoEmpresa = false;
          this.catalogos.coloniasEmpresa = [];
          this.DatosUbicacionOficina.coloniaId = null;
          break;
        case "fiscal":
          this.codigoPostalValidoFiscal = null;
          this.direccionFiscal.ciudad = "NO ENCONTRADO";
          this.direccionFiscal.estado = "NO ENCONTRADO";
          this.codigoPostalValidoFiscal = false;
          this.catalogos.coloniasFactura = [];
          this.DatosUbicacionFiscal.coloniaId = null;
          break;
      }
    },
    async ObtenerTipoPersona(prospectoId) {
      const parametros = {
        params: {
          prospectoId: prospectoId
        }
      };
      let tipoPersona = (await axios.get(rutaObtenerTipoPersona, parametros)).data;
      if (tipoPersona.estado == 0) {
        return tipoPersona.data.tipoPersona;
      }
      else {
        this.ManejarExcepcion(tipoPersona.data.mensaje);
      }
    },
    async ObtenerDatosProspecto(prospectoId) {
      const prospecto = {
        params: { prospectoId: prospectoId }
      };
      try {
        return await axios.get(rutaCargarDatosProspecto, prospecto);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async ObtenerTransicionProspecto(prospectoId, etapaId) {
      const prospecto = {
        params: { prospectoId: prospectoId, etapaId: etapaId }
      };
      try {
        return await axios.get(rutaCargarTransicionProspecto, prospecto);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async ObtenerFiguraId(prospectoId, tipoFigura) {
      const parametros = {
        params: { prospectoId: prospectoId, tipoFigura: tipoFigura }
      };
      try {
        return await axios.get(rutaObtenerFiguraId, parametros);
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    },
    async ObtenerPersonaMoral(prospectoId) {
      const prospecto = {
        params: { prospectoId: prospectoId }
      };
      try {
        return (await axios.get(rutaObtenerPersonalMoral, prospecto)).data.data;
      } catch (e) {
        this.ManejarExcepcion(e);
      }
    }
  }
};
